import { createAction, props } from '@ngrx/store';

import { IUser } from './app-authorization.reducer';

export const loadAppAuthorizationPermissions = createAction(
  '[AppAuthorization] Load AppAuthorizations Permissions',
  props<{ user: IUser }>(),
);
